import React, { Component, ReactNode } from 'react'
import { Grid, Label, StrictGridColumnProps } from 'semantic-ui-react'
import { FeatureQueryParams, Meta, getmeta, getLocalizedLabel, createDefaultFeatureLabel, valueByFormikPath, valueNotEmpty, NameQueryParams, CatchQueryParams } from '../../common'
import { FieldArray } from "formik"
import { withTranslation, WithTranslation } from 'react-i18next'
import Input from './Input'
import Dropdown from './Dropdown'
import Checkbox from './Checkbox'

export const addDefaultCatch = (query, params) => {
    const field = params.id
    if (!query._custom) query._custom = {}
    query._custom[field] = params.defaults?.value || params.value || ''
}

interface QueryProps extends WithTranslation {
    prefix: string,
    label: string|null,
    params: CatchQueryParams,
    meta: Meta,
    formik: any
}

type CatchQueryProps = QueryProps;

class CatchQuery extends Component<CatchQueryProps> {

    withPrefix(fieldName: string) {
        return `${this.props.prefix}.${fieldName}`
    }

    render () {
        const { meta, formik, prefix, params, i18n, t } = this.props

        if (params.hidden) return null

        let inputProps = {}
        const field = params.id

        let label: string|null = null
        if (typeof params.label !== 'undefined') {
            if (params.label) {
                label = getLocalizedLabel(params.label, i18n.language)
            }
        } else {
            label = t('Keywords')
        }
        if (params.icon) {
            inputProps['icon'] = params.icon
        }

        let columns = 0
        let labelComp: ReactNode = null
        if (label) {
            labelComp = (
                <Grid.Column width={2}>
                <Label htmlFor={this.withPrefix(`_custom.${field}`)} className="fieldlabel">{label}</Label>
                </Grid.Column>
            )
            columns += 2
        }
        
        const width = 16 - columns
        return (
            <React.Fragment>
                <Grid.Row verticalAlign="middle">
                    {labelComp}
                    <Grid.Column width={width as StrictGridColumnProps['width']}>
                    <Input name={this.withPrefix(`_custom.${field}`)} inputProps={inputProps}/>
                    </Grid.Column>
                </Grid.Row>
            </React.Fragment>
        )
    }
}

export default withTranslation()(CatchQuery)